import { z } from 'zod';

export const zodDeliveryNoteInternalEndpointSchema = z.tuple([
  z.literal('delivery_note'),
  z.uuid(),
  z.literal('internal'),
]);
